import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

// Both endpoints are bare `render json:`, but the ensure_permission before_action answers
// through feature_blocked's respond_to, so the format is negotiated upstream and the pair is
// what keeps the rejection JSON rather than the whole HTML page.
const NEGOTIATION_HEADERS = {
  "X-Requested-With": "XMLHttpRequest",
  "Accept": "application/json, text/plain, */*"
}

export default class extends Controller {
  static get values() { return { bannerId: String, deleteButtonId: String, modalId: String }; }

  toggleDefault(event) {
    event.preventDefault()

    const button = event.currentTarget
    if (button.getAttribute("disabled") === "disabled") { return; }

    const input = button.querySelector("input")
    const checked = input ? input.checked : undefined
    const reload = button.dataset.reload === "true"

    button.setAttribute("disabled", "disabled")

    const options = RequestHelper.defaultPatchOptions()
    options.headers = Object.assign({}, options.headers, NEGOTIATION_HEADERS,
                                    { "Content-Type": "application/json" })
    options.body = JSON.stringify({})

    fetch(button.dataset.path, options).
      then(response => {
        if (!response.ok) { throw new Error(`Template update failed (${response.status})`); }
        return response.json()
      }).
      then(({ message }) => {
        if (reload) {
          this.announceAfterVisit(message)
        } else {
          window.ltAlert({ message: message })
          if (input) { input.checked = !checked; }
        }
      }).
      catch(this.logFailedCall).
      finally(() => { button.removeAttribute("disabled") })
  }

  // The listener has to outlive this controller: Turbo replaces the body, taking any toast
  // raised before the visit with it, and disconnecting the controller along the way.
  announceAfterVisit(message) {
    const announce = () => {
      window.ltAlert({ message: message })
      document.removeEventListener("turbo:load", announce)
    }

    document.addEventListener("turbo:load", announce)
    Turbo.visit(window.location.toString())
  }

  showDeleteModal(event) {
    const path = event.currentTarget.dataset.path

    const options = RequestHelper.defaultRequestOptions()
    options.headers = Object.assign({}, options.headers, NEGOTIATION_HEADERS)

    fetch(`${path}/used_in_automations`, options).
      then(response => {
        if (!response.ok) { throw new Error(`Template usage lookup failed (${response.status})`); }
        return response.json()
      }).
      then(({ used_in_automations }) => {
        document.getElementById(this.bannerIdValue).classList.toggle("hidden", !used_in_automations)
        document.getElementById(this.deleteButtonIdValue).setAttribute("href", path)
        $(`#${this.modalIdValue}`).modal("show")
      }).
      catch(() => window.ltAlert({
        type: "toast-warning",
        message: "An error occurred while fetching template usage information."
      }))
  }

  logFailedCall(response) {
    console.warn(response)
  }
}
